module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PleaseInputToSearch":"Please input to search"},"vi":{"PleaseInputToSearch":"Không có kết quả phù hợp."}}')
  delete Component.options._Ctor
}
